export default __webpack_public_path__ + "static/media/team-circle.55319886.png";